// extracted by mini-css-extract-plugin
export default {"page":"JlWn_","container":"tMR49","map":"GS9NZ","mapPlaceholder":"DULGv","footer":"X9KkJ","withBottomSheet":"zJzqN","cancellation":"HIljB","info":"YOvqy"};